<template>
  <div
    class="skeleton-cell"
    :style="{ width: width || '100%', height: height || '1rem' }"
  ></div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
  },
};
</script>
